import { Expose } from 'class-transformer';

export class LinkProps {
  @Expose()
  label!: string;

  @Expose()
  to!: string;

  @Expose()
  type!: number;
}
